module.exports = "h2{margin-top:0}\n"